// extracted by mini-css-extract-plugin
export default {"specialDay":"Dasboard_specialDay__Y1hBl","eventBooked":"Dasboard_eventBooked__xU5UW","eventAvailable":"Dasboard_eventAvailable__Dxa9T"};